import React from 'react';
import { useHistory } from 'react-router';

import {
	Action,
	ActionGroup,
	ActionsContainer,
	ActionSVG,
} from './actionsStyles';
import {
	DirectionsIcon,
	DownloadIcon,
	NavigateIcon,
	VirtualTourIcon,
} from '../../Global/Icons/Icons';
import { useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import { shallowEqual } from 'react-redux';
import { Trail } from '../../../models/Trail';

type ActionsProps = {
	setIsVTOpen: React.Dispatch<React.SetStateAction<any>>;
	setIsNavOpen: React.Dispatch<React.SetStateAction<any>>;
	trail: Trail;
};

const Actions: React.FC<ActionsProps> = ({
	setIsVTOpen,
	setIsNavOpen,
	trail,
}) => {
	const network_status = useAppSelector(
		(state: RootState) => state.network.status,
		shallowEqual,
	);
	const handleStartDirections = () => {
		//console.log('Getting directions to start! Opening Native Maps App?');
		const maplink = `https://www.google.com/maps/search/?api=1&travelmode=driving&query=${trail.location.lat},${trail.location.lng}`;

		window.open(maplink, '_blank');
	};

	const handleNavigate = () => {
		console.log('Opening Navigation for this trail!');
		setIsNavOpen(true);
	};

	const handleVirtualTour = () => {
		console.log('Opening Virtual Tour for this trail!');
		setIsVTOpen(true);
	};

	const handleDownload = () => {
		console.log('Downloading GPX file! Cache?');
	};

	return (
		<>
			{network_status && (
				<ActionsContainer>
					<ActionGroup>
						<Action onClick={handleStartDirections}>
							<ActionSVG>
								<DirectionsIcon />
							</ActionSVG>
							<span>Getting here</span>
						</Action>
						<Action onClick={handleNavigate}>
							<ActionSVG>
								<NavigateIcon />
							</ActionSVG>
							Start trail
						</Action>

						<Action onClick={handleVirtualTour}>
							<ActionSVG>
								<VirtualTourIcon />
							</ActionSVG>
							Virtual tour
						</Action>
						{/*<Action onClick={handleDownload}>*/}
						{/*	<ActionSVG>*/}
						{/*		<DownloadIcon />*/}
						{/*	</ActionSVG>*/}
						{/*	Download*/}
						{/*</Action>*/}
					</ActionGroup>
				</ActionsContainer>
			)}
		</>
	);
};

export default Actions;
